import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { FormattedMessage } from 'react-intl';
import messages from '../../../text/messages';

class RoleSelectorList extends React.Component {
    constructor(props) {
        super(props);
        this.renderEmptyList = this.renderEmptyList.bind(this);
    }

    renderEmptyList() {
        const { logout } = this.props;

        return (
            <div className="role-selector">
                <FormattedMessage
                    id={'noRoleFound.explanation'}
                    defaultMessage={'It looks like your account is not linked to a company, please contact GreenLight support.'}
                    tagName={'p'}
                />

                <div className="roles-list row">
                    <div className="col-xs-12">
                        <Button className="col-xs-12" onClick={logout}>
                            <span className="role-title">
                                <FormattedMessage {...messages.ok} />
                            </span>
                        </Button>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { roles, onRoleSelected, logout, showLogout } = this.props;
        if (!roles || roles.length === 0) {
            return this.renderEmptyList();
        }

        return (
            <div className="role-selector">
                <FormattedMessage
                    id={'chooseRole.explanation'}
                    defaultMessage={'Your account has access to multiple company roles or companies, please select the one you wish to use.'}
                    tagName={'p'}
                />
                <FormattedMessage
                    id={'chooseRole.note'}
                    defaultMessage={'This selection is persisted only for the duration of current session.'}
                    tagName={'p'}
                />

                <div className="roles-list row">
                    {roles.map((r, i) => (
                        <div className="col-xs-12" key={i}>
                            <Button className="col-xs-12" onClick={() => onRoleSelected(r)}>
                                <div className="col-xs-12 role-container">
                                    <span className="role-title">{r.id}</span>
                                    <span className="role-info">
                                        {r.type} {r.role}
                                    </span>
                                </div>
                            </Button>
                        </div>
                    ))}
                    {showLogout && (
                        <div className="col-xs-12 logout-button">
                            <Button className="col-xs-12" onClick={logout}>
                                <span className="role-title">
                                    <FormattedMessage {...messages.logout} />
                                </span>
                            </Button>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

RoleSelectorList.defaultProps = {
    roles: [],
    onRoleSelected: () => null,
    logout: () => null,
    showLogout: false
};
RoleSelectorList.propTypes = {
    roles: PropTypes.array.isRequired,
    onRoleSelected: PropTypes.func.isRequired,
    logout: PropTypes.func.isRequired,
    showLogout: PropTypes.bool
};

export default RoleSelectorList;



// WEBPACK FOOTER //
// ./src/components/roleSelector/components/roleList.jsx